/**
 * 🔍 APPROVAL FILTERS - Componente de Filtros para Páginas de Aprovação
 * 
 * Filtros padrão: Data (from/to)
 * Reutilizável para todas as páginas de aprovação
 */

import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { Icon } from '@iconify/react';

const ApprovalFilters = ({ 
  filters, 
  onFiltersChange, 
  onClearFilters,
  loading = false 
}) => {

  return (
    <div className="card" style={{ marginBottom: '24px' }}>
      <div className="card-body">
        <Row className="g-3">
          {/* Filtro de Data Inicial */}
          <Col md={4}>
            <Form.Group>
              <Form.Label style={{ fontSize: '12px', fontWeight: '500' }}>
                Data Inicial
              </Form.Label>
              <Form.Control
                type="date"
                value={filters.date_from || ''}
                onChange={(e) => onFiltersChange({ ...filters, date_from: e.target.value })}
              />
            </Form.Group>
          </Col>

          {/* Filtro de Data Final */}
          <Col md={4}>
            <Form.Group>
              <Form.Label style={{ fontSize: '12px', fontWeight: '500' }}>
                Data Final
              </Form.Label>
              <Form.Control
                type="date"
                value={filters.date_to || ''}
                onChange={(e) => onFiltersChange({ ...filters, date_to: e.target.value })}
              />
            </Form.Group>
          </Col>

          {/* Botão Limpar Filtros */}
          <Col md={4} className="d-flex align-items-end">
            <Button
              variant="outline-secondary"
              onClick={onClearFilters}
              className="w-100"
              disabled={loading}
            >
              <Icon icon="mdi:filter-remove" className="me-1" />
              Limpar
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ApprovalFilters;

